import { render, staticRenderFns } from "./DeleteComment.vue?vue&type=template&id=14f59bb0&scoped=true&"
import script from "./DeleteComment.vue?vue&type=script&lang=js&"
export * from "./DeleteComment.vue?vue&type=script&lang=js&"
import style0 from "./DeleteComment.vue?vue&type=style&index=0&id=14f59bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f59bb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14f59bb0')) {
      api.createRecord('14f59bb0', component.options)
    } else {
      api.reload('14f59bb0', component.options)
    }
    module.hot.accept("./DeleteComment.vue?vue&type=template&id=14f59bb0&scoped=true&", function () {
      api.rerender('14f59bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/DeleteComment.vue"
export default component.exports